import { DataGrid, GridColDef } from '@mui/x-data-grid';
import React, { FunctionComponent } from 'react';

import {
  FolkloreType,
  TinderLikedUsersQuery,
} from '../../../../../apollo/__generated__/graphql';
import { folkloreNameByFolklore } from '../../../../../user/services/user.service';
import { useTinderLikedUsersQuery } from '../../../../hooks/useTinderLikedUsersQuery';

interface TinderLikedUsersTabProps {
  eventId: string;
}

const columns: GridColDef<TinderLikedUsersQuery['tinderLikedUsers'][number]>[] =
  [
    {
      field: 'tinderLikeCount',
      headerName: 'Likes',
    },
    {
      field: 'firstname',
      headerName: 'Nom',
      width: 150,
      renderCell: (params) =>
        `${params.row.firstname} ${params.row.lastname?.substring(0, 1)}.`,
    },
    {
      field: 'nickname',
      headerName: 'Surnom',
      width: 150,
    },
    {
      field: 'folklore',
      headerName: 'Folklore',
      renderCell: (params) =>
        folkloreNameByFolklore[params.row.folklore ?? FolkloreType.Other],
      width: 100,
    },
    {
      field: 'studyTown',
      headerName: 'Ville',
      width: 150,
    },
    {
      field: 'studies',
      headerName: 'Fillière',
      width: 150,
    },
  ];

export const TinderLikedUsersTab: FunctionComponent<
  TinderLikedUsersTabProps
> = ({ eventId }) => {
  const { data: userTargetsData, loading } = useTinderLikedUsersQuery(eventId);

  return (
    <DataGrid
      rows={userTargetsData?.tinderLikedUsers ?? []}
      columns={columns}
      loading={loading}
    />
  );
};
